import toast from "react-hot-toast";
import { BenefitMetricsExportParams } from "../models/benefitsMetrics";
import { useExportBenefitMetricsMutation } from "../store/services/benefits";
import { getApiErrorMessage } from "../utils/functions/api-errors";
import { downloadBlob, buildAnalyticsExportFilename } from "../utils/functions/downloadBlob";
import { useTenantOptions } from "./useTenantOptions";

/** Export CSV de metricas, compartido por el dashboard y el detalle. */
export function useBenefitsMetricsExport(): {
  exportMetrics: (params: BenefitMetricsExportParams) => Promise<void>;
  isExporting: boolean;
} {
  const [exportBenefitMetrics, { isLoading: isExporting, reset }] =
    useExportBenefitMetricsMutation();

  const { options: tenantOptions } = useTenantOptions();

  const exportMetrics = async (params: BenefitMetricsExportParams) => {
    try {
      const result = await exportBenefitMetrics(params).unwrap();

      if (result.status === 204) {
        toast("No hay canjes para los filtros seleccionados", { icon: "\u2139\ufe0f" });
        return;
      }

      downloadBlob(result.blob, buildAnalyticsExportFilename(result.filename, tenantOptions));
      toast.success("CSV exportado");
    } catch (exportError: unknown) {
      toast.error(getApiErrorMessage(exportError) ?? "Error al exportar el CSV");
    } finally {
      // Sin esto el blob queda retenido en el store de RTK hasta desmontar la pantalla.
      reset();
    }
  };

  return { exportMetrics, isExporting };
}
